module.exports = __webpack_public_path__ + "img/EDF_80X30.b4c04979.png";